"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateOwnership = exports.tokenValidatePhonePin = exports.tokenValidateIdentityPin = exports.tokenValidateEmailPin = exports.tokenValidateEmailMask = exports.socialValidateAndCreateAccount = exports.socialTokenValidatePhonePin = exports.socialPhoneConfirmationStart = exports.socialCreateAccount = exports.phoneConfirmationStart = exports.emailConfirmationStart = exports.callGandalfLogout = exports.beginSocialLogin = exports.beginSocialEmailConfirmation = exports.beginAccountOwnership = void 0;
var _index = _interopRequireDefault(require("./index"));
var _config = require("./config");
var _endpoint = require("../i18n/endpoint");
var _constants = require("../containers/Captcha/constants");
var phoneConfirmationStart = function phoneConfirmationStart(_ref) {
  var phone = _ref.phone,
    sessionId = _ref.sessionId,
    channel = _ref.channel,
    captchaToken = _ref.captchaToken,
    captchaProvider = _ref.captchaProvider;
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/phone-confirmation/start"),
    method: _config.HTTP_METHODS.POST,
    payload: {
      sessionId: sessionId,
      phone: phone,
      channel: channel,
      reCaptchaToken: captchaProvider === _constants.CAPTCHA_PROVIDERS.RECAPTCHA ? captchaToken : "",
      hCaptchaToken: captchaProvider === _constants.CAPTCHA_PROVIDERS.HCAPTCHA ? captchaToken : ""
    }
  });
};
exports.phoneConfirmationStart = phoneConfirmationStart;
var socialPhoneConfirmationStart = function socialPhoneConfirmationStart(_ref2) {
  var phone = _ref2.phone,
    sessionId = _ref2.sessionId,
    channel = _ref2.channel,
    captchaToken = _ref2.captchaToken;
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/social/phone-confirmation/start"),
    method: _config.HTTP_METHODS.POST,
    payload: {
      sessionId: sessionId,
      phone: phone,
      channel: channel,
      hCaptchaToken: captchaToken
    }
  });
};
exports.socialPhoneConfirmationStart = socialPhoneConfirmationStart;
var socialTokenValidatePhonePin = function socialTokenValidatePhonePin(_ref3) {
  var sessionId = _ref3.sessionId,
    token = _ref3.token;
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/social/token/validate?type=phone-pin"),
    method: _config.HTTP_METHODS.POST,
    payload: {
      sessionId: sessionId,
      token: token
    }
  });
};
exports.socialTokenValidatePhonePin = socialTokenValidatePhonePin;
var socialValidateAndCreateAccount = function socialValidateAndCreateAccount(_ref4) {
  var sessionId = _ref4.sessionId,
    token = _ref4.token,
    name = _ref4.name,
    email = _ref4.email,
    phone = _ref4.phone,
    acceptWhatsapp = _ref4.acceptWhatsapp,
    hasAcceptedTerms = _ref4.hasAcceptedTerms,
    accessToken = _ref4.accessToken;
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/social/validate/create-account?type=phone-pin"),
    method: _config.HTTP_METHODS.POST,
    headers: {
      Authorization: accessToken
    },
    payload: {
      sessionId: sessionId,
      token: token,
      name: name,
      email: email,
      phone: phone,
      acceptWhatsapp: acceptWhatsapp,
      hasAcceptedTerms: hasAcceptedTerms
    }
  });
};
exports.socialValidateAndCreateAccount = socialValidateAndCreateAccount;
var tokenValidateIdentityPin = function tokenValidateIdentityPin(_ref5) {
  var sessionId = _ref5.sessionId,
    token = _ref5.token;
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/identity/validate?type=phone-pin"),
    method: _config.HTTP_METHODS.POST,
    payload: {
      sessionId: sessionId,
      token: token
    }
  });
};
exports.tokenValidateIdentityPin = tokenValidateIdentityPin;
var tokenValidatePhonePin = function tokenValidatePhonePin(_ref6) {
  var sessionId = _ref6.sessionId,
    token = _ref6.token,
    riskAssessmentToken = _ref6.riskAssessmentToken;
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/token/validate?type=phone-pin"),
    method: _config.HTTP_METHODS.POST,
    payload: {
      sessionId: sessionId,
      token: token,
      riskAssessmentToken: riskAssessmentToken
    }
  });
};
exports.tokenValidatePhonePin = tokenValidatePhonePin;
var tokenValidateEmailPin = function tokenValidateEmailPin(_ref7) {
  var sessionId = _ref7.sessionId,
    token = _ref7.token,
    riskAssessmentToken = _ref7.riskAssessmentToken;
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/token/validate?type=email-pin"),
    method: _config.HTTP_METHODS.POST,
    payload: {
      sessionId: sessionId,
      token: token,
      riskAssessmentToken: riskAssessmentToken
    }
  });
};
exports.tokenValidateEmailPin = tokenValidateEmailPin;
var tokenValidateEmailMask = function tokenValidateEmailMask(_ref8) {
  var sessionId = _ref8.sessionId,
    email = _ref8.email,
    riskAssessmentToken = _ref8.riskAssessmentToken;
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/token/validate?type=email-mask"),
    method: _config.HTTP_METHODS.POST,
    payload: {
      sessionId: sessionId,
      token: email,
      riskAssessmentToken: riskAssessmentToken
    }
  });
};
exports.tokenValidateEmailMask = tokenValidateEmailMask;
var emailConfirmationStart = function emailConfirmationStart(_ref9) {
  var sessionId = _ref9.sessionId,
    name = _ref9.name,
    email = _ref9.email,
    phone = _ref9.phone,
    birthDate = _ref9.birthDate,
    acceptWhatsapp = _ref9.acceptWhatsapp,
    hasAcceptedTerms = _ref9.hasAcceptedTerms,
    longLivedSession = _ref9.longLivedSession,
    documentType = _ref9.documentType,
    documentValue = _ref9.documentValue;
  var userDocuments;
  if (documentType && documentValue) {
    userDocuments = [{
      documentType: documentType,
      documentValue: documentValue
    }];
  }
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/email-confirmation/start"),
    method: _config.HTTP_METHODS.POST,
    payload: {
      sessionId: sessionId,
      name: name,
      email: email,
      phone: phone,
      birthDate: birthDate,
      acceptWhatsapp: acceptWhatsapp,
      hasAcceptedTerms: hasAcceptedTerms,
      longLivedSession: longLivedSession,
      userDocuments: userDocuments
    }
  });
};
exports.emailConfirmationStart = emailConfirmationStart;
var socialCreateAccount = function socialCreateAccount(_ref10) {
  var sessionId = _ref10.sessionId,
    name = _ref10.name,
    email = _ref10.email,
    phone = _ref10.phone,
    acceptWhatsapp = _ref10.acceptWhatsapp,
    hasAcceptedTerms = _ref10.hasAcceptedTerms,
    longLivedSession = _ref10.longLivedSession,
    documentType = _ref10.documentType,
    documentValue = _ref10.documentValue,
    accessToken = _ref10.accessToken;
  var userDocuments;
  if (documentType && documentValue) {
    userDocuments = [{
      documentType: documentType,
      documentValue: documentValue
    }];
  }
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/social/create-account"),
    method: _config.HTTP_METHODS.POST,
    headers: {
      Authorization: accessToken
    },
    payload: {
      sessionId: sessionId,
      name: name,
      email: email,
      phone: phone,
      acceptWhatsapp: acceptWhatsapp,
      hasAcceptedTerms: hasAcceptedTerms,
      longLivedSession: longLivedSession,
      userDocuments: userDocuments
    }
  });
};
exports.socialCreateAccount = socialCreateAccount;
var beginSocialLogin = function beginSocialLogin(_ref11) {
  var accessToken = _ref11.accessToken;
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/social/login"),
    method: _config.HTTP_METHODS.POST,
    headers: {
      Authorization: accessToken
    }
  });
};
exports.beginSocialLogin = beginSocialLogin;
var beginAccountOwnership = function beginAccountOwnership(_ref12) {
  var sessionToken = _ref12.sessionToken,
    channel = _ref12.channel;
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/social/account-ownership/start"),
    method: _config.HTTP_METHODS.POST,
    payload: {
      sessionToken: sessionToken,
      channel: channel
    }
  });
};
exports.beginAccountOwnership = beginAccountOwnership;
var validateOwnership = function validateOwnership(_ref13) {
  var sessionId = _ref13.sessionId,
    pinCode = _ref13.pinCode,
    accessToken = _ref13.accessToken,
    type = _ref13.type;
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/social/account-ownership/validate?type=").concat(type),
    method: _config.HTTP_METHODS.POST,
    headers: {
      Authorization: accessToken
    },
    payload: {
      sessionId: sessionId,
      token: pinCode
    }
  });
};
exports.validateOwnership = validateOwnership;
var beginSocialEmailConfirmation = function beginSocialEmailConfirmation(_ref14) {
  var sessionToken = _ref14.sessionToken;
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(), "/social/email-confirmation/start"),
    method: _config.HTTP_METHODS.POST,
    payload: {
      sessionToken: sessionToken
    }
  });
};
exports.beginSocialEmailConfirmation = beginSocialEmailConfirmation;
var callGandalfLogout = function callGandalfLogout(topLevelDomain) {
  return (0, _index.default)({
    endpoint: "".concat((0, _endpoint.getLoginAPIUrl)(topLevelDomain), "/v1/logout"),
    method: "POST",
    body: {}
  });
};
exports.callGandalfLogout = callGandalfLogout;